/* <surisa-product-tabs> — switch de pestañas del PDP (WAI-ARIA tabs).
   Envuelve .pdp__tabs (tablist) + .pdp__tabs-body (paneles). Es un custom
   element para que connectedCallback se re-ejecute tras el full-page re-render
   que hace product-info.js al cambiar de variante (viewTransition sobre <main>).

   Contrato: cada [role="tab"] tiene data-tab="<id>"; cada panel [data-panel="<id>"].
   El tab activo en SSR lleva aria-selected="true". */
(function () {
  if (customElements.get('surisa-product-tabs')) return;

  customElements.define('surisa-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-panel]'));
      if (this.tabs.length === 0) return;
      var self = this;
      this.tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { self.select(tab); });
        tab.addEventListener('keydown', function (e) { self.onKey(e, i); });
        if (!tab.hasAttribute('tabindex')) {
          tab.setAttribute('tabindex', tab.getAttribute('aria-selected') === 'true' ? '0' : '-1');
        }
      });
    }

    _panelFor(tab) {
      var id = tab.getAttribute('data-tab');
      return this.panels.filter(function (p) { return p.getAttribute('data-panel') === id; })[0];
    }

    select(tab) {
      var self = this;
      this.tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.setAttribute('tabindex', on ? '0' : '-1');
        var panel = self._panelFor(t);
        if (panel) panel.hidden = !on;
      });
    }

    onKey(e, i) {
      var n = this.tabs.length;
      var idx = null;
      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown': idx = (i + 1) % n; break;
        case 'ArrowLeft':
        case 'ArrowUp':   idx = (i - 1 + n) % n; break;
        case 'Home':      idx = 0; break;
        case 'End':       idx = n - 1; break;
        case 'Enter':
        case ' ':         e.preventDefault(); this.select(this.tabs[i]); return;
        default:          return;
      }
      e.preventDefault();
      this.tabs[idx].focus();
      this.select(this.tabs[idx]);
    }
  });
})();
